import { render, staticRenderFns } from "./ShopifyProductItem.vue?vue&type=template&id=e7977792&scoped=true&lang=pug&"
import script from "./ShopifyProductItem.vue?vue&type=script&lang=js&"
export * from "./ShopifyProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyProductItem.vue?vue&type=style&index=0&id=e7977792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7977792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VImg,VRow})
